import React from 'react';
import { Button, FormControl, ControlLabel, Alert } from 'react-bootstrap';
import { login, isLoggedIn } from '../utils/AuthService';

var Login = React.createClass({

  getInitialState: function() {
    return {
      login: '',
      password: '',
      error: null,
      loading: false,
    };
  },

  componentDidMount: function() {
    if (isLoggedIn()) window.location.href = '/';
  },

  onLoginChange: function(e) {
    this.setState({ login: e.target.value });
  },

  onPasswordChange: function(e) {
    this.setState({ password: e.target.value });
  },

  onKeyDown: function(e) {
    if (e.key === 'Enter' && !this.state.loading) this.onSubmit();
  },

  onSubmit: function() {
    var self = this;
    if (!this.state.login || !this.state.password) {
      this.setState({ error: 'Wpisz login i haslo' });
      return;
    }
    this.setState({ loading: true, error: null });
    login(this.state.login, this.state.password)
      .then(function() {
        window.location.href = '/';
      })
      .catch(function(err) {
        var msg = (err && err.response && err.response.data && err.response.data.error)
          ? err.response.data.error
          : 'Blad logowania';
        self.setState({ error: msg, loading: false });
      });
  },

  render: function() {
    var boxStyle = {
      maxWidth: 380,
      margin: '80px auto',
      padding: 28,
      background: '#fff',
      border: '1px solid #ddd',
      borderRadius: 6,
      boxShadow: '0 2px 6px rgba(0,0,0,0.05)',
    };
    return (
      <div style={boxStyle}>
        <h3 style={{ marginTop: 0, marginBottom: 20, textAlign: 'center' }}>Logowanie</h3>

        {this.state.error ? <Alert bsStyle="danger">{this.state.error}</Alert> : null}

        <div style={{ marginBottom: 12 }}>
          <ControlLabel>Login</ControlLabel>
          <FormControl
            type="text"
            value={this.state.login}
            onChange={this.onLoginChange}
            onKeyDown={this.onKeyDown}
            autoFocus={true}
          />
        </div>

        <div style={{ marginBottom: 18 }}>
          <ControlLabel>Hasło</ControlLabel>
          <FormControl
            type="password"
            value={this.state.password}
            onChange={this.onPasswordChange}
            onKeyDown={this.onKeyDown}
          />
        </div>

        <Button
          bsStyle="primary"
          block={true}
          disabled={this.state.loading}
          onClick={this.onSubmit}>
          {this.state.loading ? 'Logowanie...' : 'Zaloguj'}
        </Button>
      </div>
    );
  }
});

export default Login;



// WEBPACK FOOTER //
// ./src/components/Login.js